import {
  LijfrenteSoort,
  LijfrenteUitkeringInfo,
  BetalingsTermijnType,
} from "../../../../.generated/rapportage/rapportagetypes";
import { Column } from "../../components/BaseTable";
import { formatCurrencyWithDecimals } from "../../../formatters";

const getTermijn = (termijn: BetalingsTermijnType | null): string => {
  switch (termijn) {
    case BetalingsTermijnType.Geen:
      return "geen";
    case BetalingsTermijnType.Maand:
      return "maand";
    case BetalingsTermijnType.TweeMaanden:
      return "twee maanden";
    case BetalingsTermijnType.Kwartaal:
      return "kwartaal";
    case BetalingsTermijnType.HalfJaar:
      return "half jaar";
    case BetalingsTermijnType.Jaar:
      return "jaar";
    case BetalingsTermijnType.Eenmalig:
      return "eenmalig";
    case BetalingsTermijnType.Dag:
      return "dag";
    case BetalingsTermijnType.Week:
      return "week";
    default:
      return "";
  }
};

export const getLijfrentesColumns = (
  soortProduct?: LijfrenteSoort,
  isHuidig?: boolean
): Column<LijfrenteUitkeringInfo>[] => {
  let lijfrenteOmschrijving = "Lijfrente";
  if (soortProduct === LijfrenteSoort.Lijfrente) {
    lijfrenteOmschrijving = "Lijfrenteverzekering";
  } else if (soortProduct === LijfrenteSoort.BancaireLijfrente) {
    lijfrenteOmschrijving = "Bancaire lijfrente";
  }
  return [
    { header: lijfrenteOmschrijving ?? "", accessor: (row) => " " },
    {
      header: "Lopend of nieuwe polis",
      accessor: (row) =>
        isHuidig
          ? "Bestaande polis"
          : !row.nieuwePolis
          ? "Lopende polis"
          : "Nieuwe polis",
    },
    {
      header: "Instelling",
      accessor: "maatschappij",
    },
    {
      header: "Soort",
      accessor: (row) =>
        row.soortLijfrente === LijfrenteSoort.Lijfrente
          ? "Lijfrenteverzekering"
          : "Bancaire lijfrente",
    },
    {
      header: "Ingangsdatum",
      accessor: "aanvangUitkeringDatum",
      dataType: "date",
    },
    {
      header: "Contractant",
      accessor: "contractanten",
    },
    {
      header: "Verzekeringnemer",
      accessor: "verzekeringnemers",
    },
    {
      header: "Verzekerde(n)",
      accessor: "verzekerden",
    },
    {
      header: "Rekeningnummer",
      accessor: "rekeningnummer",
    },
    {
      header: "Beschikbare koopsom",
      accessor: "beschikbareKoopsom",
      dataType: "currency",
    },
    {
      header: "Uitkering valt fiscaal in",
      accessor: "box",
    },
    {
      header: "Gehanteerd lijfrentetarief",
      accessor: "lijfrenteTarief",
      dataType: "percentage",
    },
    {
      header: "Overgang op 2e verzekerde",
      accessor: "overgangOpPartner",
    },
    {
      header: "Einddatum hoge lijfrente-uitkering",
      accessor: "einddatumHoog",
      dataType: "date",
    },
    {
      header: "Hoge lijfrente-uitkering",
      accessor: (row: LijfrenteUitkeringInfo) =>
        row.uitkeringHoog !== null
          ? formatCurrencyWithDecimals(row.uitkeringHoog) +
            ` per ${getTermijn(row.uitkeringstermijn)}`
          : null,
    },
    {
      header: "Duur lijfrente-uitkering",
      accessor: "duur",
    },
    {
      header: "Einddatum lijfrente-uitkering",
      accessor: "einddatum",
      dataType: "date",
    },
    {
      header: "Lijfrente-uitkering",
      accessor: (row: LijfrenteUitkeringInfo) =>
        row.termijnuitkering !== null
          ? formatCurrencyWithDecimals(row.termijnuitkering) +
            ` per ${getTermijn(row.uitkeringstermijn)}`
          : null,
    },
  ];
};
